// @greenlight-spec: 16-api-conventions.md
import { APP_SLUG_REGEX, GITHUB_ORG_LOGIN_REGEX, ORG_SLUG_REGEX } from '../constants/index.js';
export { APP_SLUG_REGEX, GITHUB_ORG_LOGIN_REGEX, ORG_SLUG_REGEX };
export const isValidAppSlug = (value) => APP_SLUG_REGEX.test(value);
export const isValidOrgSlug = (value) => ORG_SLUG_REGEX.test(value);
export const isValidGithubOrgLogin = (value) => GITHUB_ORG_LOGIN_REGEX.test(value);
/**
 * The slug the install gives its org: up to 15 characters derived from the
 * display name (or `org` when none survive), a hyphen, and a 5-character
 * suffix. It never refuses a name. The GitHub App's default name is
 * `Greenlight - <slug>`, which must fit GitHub's 34-character limit and be
 * unique across GitHub; the suffix keeps two orgs with the same name apart.
 */
export function installOrgSlug(name, suffix) {
    const base = name
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^[-0-9]+/, '')
        .slice(0, 15)
        .replace(/-+$/, '');
    return `${base || 'org'}-${suffix}`;
}
//# sourceMappingURL=slug.js.map